import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { styled, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useSelector, useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
import Spin from 'components/Spin';
import { getQuestions } from 'services/connect-card.service';
import { selectConnectCard } from 'store/modules/connect-cards/selectors';
import { getConnectCard } from 'store/modules/connect-cards/actions';
import ConnectCard from './ConnectCard';
import getTheme from '../../utils/getTheme';
import { getAccountLogoUrl } from '../../utils';
import { getConnectCardUrl } from 'modules/connect-card/utils';

const WidgetInner = styled(Box)`
  padding-top: max(5rem, 8vh);
  padding-bottom: 2rem;
  max-width: 600px;
  margin: auto;
`;

const CardPage = ({
  match: {
    params: { id },
  },
}) => {
  const [questions, setQuestions] = useState([]);
  const dispatch = useDispatch();
  const { data: card, loading } = useSelector(selectConnectCard(id));
  const contact = useSelector((s) => s.dcc.contact);

  useEffect(() => {
    if (!card && !loading) {
      dispatch(getConnectCard(id));
    }
    getQuestions(id).then((resp) => {
      setQuestions(resp);
    });
  }, []);

  const onSubmitComplete = () => {};

  if (!card) return <Spin spinning />;

  const theme = getTheme({
    primary: card.card_background_color || card.account.account_color,
    text: card.card_text_color,
  });

  const accountLogoUrl = getAccountLogoUrl(card.account);
  const logoUrl = card.logo_or_video_url || accountLogoUrl;

  return (
    <Box height="100vh" overflow="auto">
      <Helmet title={card.card_headline}>
        <meta name="title" content={card.card_headline} />
        <meta name="description" content={card.card_description} />
        <meta property="og:title" content={card.card_headline} />
        <meta property="og:description" content={card.card_description} />
        <meta property="og:image" content={logoUrl} />
        <meta property="og:url" content={getConnectCardUrl(card)} />
        <meta name="twitter:card" content={logoUrl} />
        <meta name="twitter:title" content={card.card_headline} />
        <meta name="twitter:description" content={card.card_description} />
        <meta name="twitter:image" content={logoUrl} />
      </Helmet>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <WidgetInner>
          {questions.length ? (
            <ConnectCard
              onSubmitComplete={onSubmitComplete}
              account={card.account}
              data={card}
              contact={contact}
              questions={questions}
            />
          ) : (
            <Spin spinning size={40} />
          )}
        </WidgetInner>
      </ThemeProvider>
    </Box>
  );
};

export default CardPage;
